class GnlParametreDTO {
    id?: number = 0;
    kodu?: number = null;
    adi?: string = "";
    grupId?: number = null;
    aktif?: string = "E";
    aktifBool?: boolean = true;
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    sirano?: number = null;
    alan01?: string = "";
    kartTipiSor?: string = "H";
    yazarKasaYok?: string = "";
    sablonId?: number = null;
}
export default GnlParametreDTO;